<template>
    <div class="block-editor send-sms">
        <div class="wrapper">
            <div class="title">{{ $t('auto.sendSMSSMSProvider') }}</div>
            <div class="text-editor-wrapper">
                <a-select v-model="clone.channelId" :defaultValue="null">
                    <a-select-option :selected="true" value="null">{{ $t('auto.sendSMSSelectSmsProvider') }}</a-select-option>
                    <a-select-option :key="channel._id" v-for="channel of smsChannels" :value="channel._id">
                        {{ channel.name }} <span class="provider-badge">{{ getProviderLabel(channel.type) }}</span>
                    </a-select-option>
                </a-select>
            </div>
            <div class="selected-provider" v-if="selectedChannelType">
                <span class="provider-badge">{{ getProviderLabel(selectedChannelType) }}</span>
            </div>
        </div>
        <div class="wrapper" v-if="selectedChannelType === 'sms-postacell' || selectedChannelType === 'sms-netgsm'">
            <div class="title">{{ $t('auto.sendSMSSenderId') }}</div>
            <div class="text-editor-wrapper">
                <a-select v-model="clone.senderId" :defaultValue="null">
                    <a-select-option
                        v-for="sender of senders"
                        :value="sender.title"
                        :key="sender.uuid"
                    >
                        {{ sender.title }}
                        <span v-if="sender.title === netgsmDefaultSender" class="default-sender-badge">
                            {{ $t('message.defaultSender') }}
                        </span>
                    </a-select-option>
                    <a-select-option :value="''">
                        {{ $t('auto.sendSMSSelectSender') }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="provider-hint" v-if="selectedChannelType === 'sms-netgsm' && netgsmDefaultSender && !clone.senderId">
                {{ $t('message.defaultSender') }}: {{ netgsmDefaultSender }}
            </div>
        </div>
        <div class="wrapper" v-if="selectedChannelType === 'sms-posta-guvercini'">
            <div class="provider-hint">{{ $t('message.postaGuverciniSenderInfo') }}</div>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t('auto.sendSMSPhoneNumber') }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="Phone Number"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.number"
                    automation-mode
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="title">{{ $t('auto.sendSMSMessage') }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="Mesajınızı Buraya Yazın."
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.message"
                    :max-character-count="160"
                    automation-mode
                />
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import { mapActions, mapState } from "vuex";

const log = log2("SendSMS");
export default {
    name: "SendSMS",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            senders: [],
            credit: 0,
        };
    },
    computed: {
        ...mapState({
            smsChannels: (state) =>
                state.channel.channels.filter(
                    (x) =>
                        x.type === "sms-postacell" ||
                        x.type === "sms-netgsm" ||
                        x.type === "sms-posta-guvercini"
                ),
        }),
        selectedChannel() {
            return _.find(this.smsChannels, (c) => c._id === this.clone.channelId) || null;
        },
        selectedChannelType() {
            return _.get(this.selectedChannel, "type", "");
        },
        netgsmDefaultSender() {
            if (this.selectedChannelType !== "sms-netgsm") return "";
            return _.get(this.selectedChannel, "payload.defaultSender", "") || "";
        },
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            getPostacellChannelSenders: "channel/getPostacellChannelSenders",
            getNetgsmChannelSenders: "channel/getNetgsmChannelSenders",
        }),
        getProviderLabel(type) {
            const labels = {
                "sms-postacell": "Postacell",
                "sms-netgsm": "Netgsm",
                "sms-posta-guvercini": "Posta Güvercini",
            };
            return labels[type] || "";
        },
        initSenders() {
            this.senders = [];
            if (!this.clone.channelId) return;
            const type = this.selectedChannelType;
            if (type === "sms-postacell") {
                this.getPostacellChannelSenders(this.clone.channelId).then((data) => {
                    this.senders = _.get(data, "list", []);
                });
            } else if (type === "sms-netgsm") {
                this.getNetgsmChannelSenders(this.clone.channelId).then((data) => {
                    this.senders = _.get(data, "list", []);
                });
            }
        },
    },
    mounted() {
        this.initSenders();
        this.listChannels();
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.channelId": {
            handler() {
                this.initSenders();
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.send-sms {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .ant-select {
            width: 100%;
        }

        .selected-provider {
            margin-top: 6px;
        }

        .provider-badge {
            display: inline-block;
            padding: 1px 8px;
            margin-left: 4px;
            font-size: 11px;
            font-weight: 600;
            line-height: 16px;
            color: #1890ff;
            background: #e6f4ff;
            border: 1px solid #91caff;
            border-radius: 10px;
        }

        .provider-hint {
            padding: 8px 10px;
            margin-top: 6px;
            font-size: 12px;
            color: #6b7280;
            background: #f3f4f6;
            border: 1px solid #e5e7eb;
            border-radius: 4px;
        }

        .default-sender-badge {
            display: inline-block;
            padding: 0 6px;
            margin-left: 6px;
            font-size: 10px;
            font-weight: 600;
            line-height: 16px;
            color: #52c41a;
            background: #f6ffed;
            border: 1px solid #b7eb8f;
            border-radius: 8px;
        }
    }
}
</style>
